
<div>
  <b-modal
    @ok="e => $emit('ok', e)"
    @hidden="e => $emit('hidden', e)"
    @cancel="e => $emit('cancel', e)"
    size="m"
    :id="dialogId"
    :title="dialogTitle"
    :centered="dialogVerticalCenter"
  >
    <div class="form-row">
      {{ dialogMessage }}
    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button size="sm" variant="outline-secondary" @click="cancel()">
        No
      </b-button>
      <b-button size="sm" variant="primary" @click="ok()">
        Yes
      </b-button>
    </template>
  </b-modal>
</div>
